
<div class="main-div aita-engine">
    <div class="logo-div">
        <img class="logo" src="assets/img/AITA logo.png" alt="AITA Logo" (click)="goTologin()" />
    </div>
    <app-search-bar></app-search-bar>
</div>
